import React from 'react';
import { AnnouncementBar } from '../components/AnnouncementBar';
import { Footer } from '../components/Footer';
export const TermsAndConditions = () => {
  return <div className="w-full min-h-screen bg-white flex flex-col" data-id="element-311">
      <AnnouncementBar data-id="element-312" />
      <main className="flex-1 w-full" data-id="element-313">
        <div className="max-w-[780px] mx-auto px-4 md:px-6 py-12 md:py-20" data-id="element-314">
          <h1 className="font-playfair text-[28px] md:text-[32px] text-primary mb-8" data-id="element-315">
            Terms and Conditions
          </h1>

          <div className="font-lato text-[16px] text-body" style={{
          lineHeight: 1.8
        }} data-id="element-316">
            <p className="mb-5" data-id="element-317">
              <strong data-id="element-318">Last updated: January 2026</strong>
            </p>

            <p className="mb-5" data-id="element-319">
              By purchasing The Hormonal Balance Code, you agree to the
              following terms:
            </p>

            <h2 className="font-playfair text-[20px] text-primary mt-6 mb-3" data-id="element-320">
              1. Digital Product Delivery
            </h2>
            <p className="mb-5" data-id="element-321">
              All products are delivered digitally via immediate download after
              purchase. No physical products will be shipped.
            </p>

            <h2 className="font-playfair text-[20px] text-primary mt-6 mb-3" data-id="element-322">
              2. Refund Policy
            </h2>
            <p className="mb-5" data-id="element-323">
              We offer a 30-day money-back guarantee. If you are not satisfied
              with your purchase, contact us within 30 days for a full refund.
              No questions asked.
            </p>

            <h2 className="font-playfair text-[20px] text-primary mt-6 mb-3" data-id="element-324">
              3. Intellectual Property
            </h2>
            <p className="mb-5" data-id="element-325">
              All content included in this product is protected by copyright.
              You may not reproduce, distribute, or resell any part of this
              material without written permission.
            </p>

            <h2 className="font-playfair text-[20px] text-primary mt-6 mb-3" data-id="element-326">
              4. Health Disclaimer
            </h2>
            <p className="mb-5" data-id="element-327">
              The information provided in these materials is educational in
              nature and does not constitute medical advice. Always consult a
              qualified healthcare provider before making changes to your health
              regimen.
            </p>

            <h2 className="font-playfair text-[20px] text-primary mt-6 mb-3" data-id="element-328">
              5. Limitation of Liability
            </h2>
            <p className="mb-8" data-id="element-329">
              Results may vary. Individual outcomes depend on personal health
              history, consistency of application, and other individual factors.
            </p>

            <a href="#/" className="font-lato text-[15px] hover:underline" style={{
            color: '#957DAD'
          }} data-id="element-330">
              ← Back to main page
            </a>
          </div>
        </div>
      </main>
      <Footer data-id="element-331" />
    </div>;
};